import { v4 } from 'uuid'
import axios from 'axios'
import moment from 'moment-timezone'

import {
  CallDetailsInformation,
  ReasonCategory,
  NotScamReason,
  ScamReason,
  WrongCategoryReason
} from '@/types'

import config from '@/config'

function isTest () {
  return document.location.origin.includes('tst-') ||
    document.location.origin.includes('staging') ||
    document.location.origin.includes('localhost')
}

function getBaseURL () {
  return isTest()
    ? 'https://tst-feedback.fosrvt.com/form'
    : 'https://feedback.fosrvt.com/form'
}

function getCategory (details: CallDetailsInformation) {
  if (details.category === ReasonCategory.NotScamLikely) {
    return '1'
  } else if (details.category === ReasonCategory.ScamLikely) {
    return '1'
  } else if (details.category === ReasonCategory.WrongCategory) {
    switch (details.reason) {
      case WrongCategoryReason.Telemarketing: return '2'
      case WrongCategoryReason.Political: return '4'
      case WrongCategoryReason.Survey: return '5'
      case WrongCategoryReason.Charity: return '6'
      case WrongCategoryReason.Prison: return '7'
      case WrongCategoryReason.PotentialSpam: return '10'
      case WrongCategoryReason.Other: return '12'
      default: return ''
    }
  }

  return ''
}

function getReportReasonScam (details: CallDetailsInformation) {
  if (details.category === ReasonCategory.NotScamLikely) {
    return '1'
  } else if (details.category === ReasonCategory.ScamLikely) {
    return '2'
  }

  return ''
}

function buildRequestBody (details: CallDetailsInformation, recaptchaToken: string) {
  return {
    payload: {
      captcha: recaptchaToken,
      tid: v4(),
      fid: 8,
      src: 3,
      ts: moment().format('X'),
      tz: moment.tz.guess() || 'America/Chicago',
      // eslint-disable-next-line
      report_time: moment().format('MM/DD/YYYY HH:mm A'),
      cnum: details.number.replace('-', ''),
      cnam: details.name ?? '',
      callTime: details.time,
      callDate: details.date,
      answers: [
        // Category
        {
          question: 'category',
          answer: getCategory(details)
        },

        // Report Reason Scam
        {
          question: 'report_reason',
          answer: getReportReasonScam(details)
        },

        // Known Personally
        {
          question: 'report_reason',
          subquestion: 'know-personally',
          answer: details.reason === NotScamReason.KnowPersonally ? 'on' : ''
        },

        // Prior Engagement
        {
          question: 'report_reason',
          subquestion: 'prior-engagement',
          answer: details.reason === NotScamReason.PriorEngagement ? 'on' : ''
        },

        // Event Notification
        {
          question: 'report_reason',
          subquestion: 'event-notification',
          answer: details.reason === NotScamReason.EventNotification ? 'on' : ''
        },

        // IRS Scam
        {
          question: 'report_reason',
          subquestion: 'scam-irs',
          answer: details.reason === ScamReason.IRS ? 'on' : ''
        },

        // Debt Scam
        {
          question: 'report_reason',
          subquestion: 'scam-debt',
          answer: details.reason === ScamReason.Debt ? 'on' : ''
        },

        // Credit Card Scam
        {
          question: 'report_reason',
          subquestion: 'scam-credit',
          answer: details.reason === ScamReason.CreditCard ? 'on' : ''
        },

        // PC Support Scam
        {
          question: 'report_reason',
          subquestion: 'scam-pc',
          answer: details.reason === ScamReason.PC ? 'on' : ''
        },

        // Other Scam
        {
          question: 'report_reason',
          subquestion: 'scam-other',
          answer: (details.category === ReasonCategory.ScamLikely &&
            details.reason === ScamReason.Other) ? 'on' : ''
        },

        // Is Pre-Recorded
        {
          question: 'pre-recorded',
          answer: details.isPrerecorded ? 'on' : ''
        }
      ]
    }
  }
}

export async function sendReport (details: CallDetailsInformation, recaptchaToken: string) {
  return axios.post(
    getBaseURL(),
    buildRequestBody(details, recaptchaToken)
  )
}

export function convert24HTimeTo12H (time: string | null) {
  if (time) {
    return moment(time, ['HH:mm']).format('hh:mm A')
  } else {
    return ''
  }
}

export function openDoNotSellPage (isMagenta: boolean) {
  const domain = 'https://www.t-mobile.com'
  const mapForm = document.createElement('form')
  mapForm.target = 'myWindow'
  mapForm.method = 'post'
  mapForm.action = 'https://www.t-mobile.com/dns'

  const mapInput1 = document.createElement('input')
  mapInput1.type = 'text'
  mapInput1.name = 'Brand'
  mapInput1.value = isMagenta ? 'Magenta' : 'MbyT'
  mapForm.appendChild(mapInput1)

  const mapInput2 = document.createElement('input')
  mapInput2.type = 'text'
  mapInput2.name = 'LocaldoNotSellSetting'
  mapInput2.value = 'DoNotSell'
  mapForm.appendChild(mapInput2)

  const mapInput3 = document.createElement('input')
  mapInput3.type = 'text'
  mapInput3.name = 'Origin_URL'
  mapInput3.value = document.location.origin
  mapForm.appendChild(mapInput3)

  const mapInput4 = document.createElement('input')
  mapInput4.type = 'text'
  mapInput4.name = 'Site'
  mapInput4.value = 'NoSell_Web'
  mapForm.appendChild(mapInput4)

  document.body.appendChild(mapForm)
  window.open(domain + '/dns', 'myWindow', 'width=800,height=800,resizeable,scrollbars')
  mapForm.submit()
  document.body.removeChild(mapForm)
}

export function getCallReportingHomeURL () {
  const stagingSubDomain = isTest() ? 'staging.' : ''
  return config.isMagenta
    ? 'https://' + stagingSubDomain + 'callreporting.t-mobile.com/'
    : 'https://' + stagingSubDomain + 'callreporting.metrobyt-mobile.com/'
}

export function getRecaptchaSiteKey () {
  return isTest()
    ? '6LeWHKkhAAAAABs63K28Lvxg54maw2CYvznvLwbX'
    : '6LfkIqkhAAAAAOGJ0DAz05G-Bsc0vnKKl9GC3QZJ'
}
